var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "omni-theme-picker"
  }, [_c('div', {
    staticClass: "theme-boxes"
  }, _vm._l(_vm.availableThemes, function (theme, key) {
    return _c('ThemeBox', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      key: key,
      attrs: {
        "backgroundColor": theme.colors[0],
        "foregroundColor": theme.colors[1],
        "active": _vm.selectedTheme === key,
        "title": `Thema '${theme.display_name}' selecteren`
      },
      on: {
        "click": function ($event) {
          return _vm.selectTheme(key);
        }
      }
    });
  }), 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }